<template>
  <layout>
    <div class="section">
      <div class="content">
        <div style="color: #333333; font-size: 24px; font-weight: Bold">
          Whois 查询
        </div>
        <div class="search-input-warp">
          <div class="flex-content">
            <Input
              class="search-input"
              placeholder="请输入域名信息"
              clearable
              v-model.trim="search"
              maxlength="30"
              @on-keyup="change"
              @on-enter="searchEvnet"
            ></Input>
            <Button class="search-btn" type="primary" @click="searchEvnet">
              <img src="@/assets/image/search@2x.png" alt="" />
              <span>查询</span>
            </Button>
          </div>
        </div>

        <div class="contentBox-bottom" style="position: relative">
          <div v-if="!noData && !noResult" class="whois-content">
            <loading :loading="loadings" style="z-index: 11"></loading>
            <div class="whois-top">
              <div class="whios-title">
                域名
                <span
                  style="font-size: 30px; font-weight: bold; color: #3992e9"
                  >{{ info.dn }}</span
                >
                注册信息
                <span style="float: right; cursor: pointer" @click="refreshWhois">获取最新信息</span>
              </div>
              <div style="margin-top: 16px">
                <div class="flx-row-s-s info-item" style="margin-top: 16px">
                  <div class="info-title">域名:</div>
                  <div class="info-text">{{ info.dn }}</div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">域名状态:</div>
                  <div class="info-text">
                    <p v-for="item in info.status" :key="item">
                      {{ item }}
                    </p>
                  </div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">注册联系电话:</div>
                  <div class="info-text">{{ info.contactTelphone }}</div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">注册者联系电子邮箱:</div>
                  <div class="info-text">{{ info.contactMail }}</div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">注册商:</div>
                  <div class="info-text">{{ info.registrar }}</div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">DNS服务器:</div>
                  <div class="info-text">
                    <p v-for="(item, index) in info.dns" :key="item">
                      DNS{{ index + 1 }}：{{ item }}
                    </p>
                    <p v-if="info.dns.length === 0">暂无数据</p>
                  </div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">注册日期:</div>
                  <div class="info-text">{{ info.registrationDateTime }}</div>
                </div>
                <div class="flx-row-s-s info-item">
                  <div class="info-title">过期时间:</div>
                  <div class="info-text">{{ info.expirationDateTime }}</div>
                </div>
              </div>
            </div>
            <div class="whois-bottom">
              <div class="eng-title">
                <span class="title-inner">详细英文注册信息</span>
              </div>
              <div class="content" v-html="info.details || ''"></div>
            </div>
          </div>
          <div v-if="noData" class="noData-content" style="align-items: center">
            <span class="c-o">“{{ search }}”</span>未查询到whois信息<span
              style="color: #3992e9; margin-left: 5px; cursor: pointer"
              @click="toRegister(search)"
            >
              >> 立即注册</span
            >
          </div>
          <div
            v-if="noResult"
            class="noData-content flx-col-c-s"
            style="flex-direction: column; justify-content: center"
          >
            <div style="font-size: 20px; color: #333">未查询到whois信息</div>
            <div style="font-size: 14px; color: #333; margin-top: 10px">
              该域名可能被注册局保留、正在审核或限制注册，暂无whois信息
            </div>
          </div>
        </div>
      </div>
      <captcha ref="childCaptcha" @custom-event="getCodeEvent"></captcha>
    </div>
  </layout>
</template>


<script>
import layout from "./components/layout.vue";
import loading from "components/loading.vue";
import { getCaptchaWhoisV1, getCaptchaWhoisV2  } from "api/domain.js";
import captcha from "components/captcha.vue";
const domain =
  // eslint-disable-next-line max-len
  /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;
export default {
  name: "price",
  components: {
    layout,
    loading,
    captcha
  },
  data() {
    return {
      showNav: false,
      loadings: false,
      search: "",
      info: {
        details: "",
        dns: [],
        name: "",
        contactMail: "",
        endDateTime: "",
        contactPhone: "",
        registrar: "",
        registrationTime: "",
        status: [],
      },

      // 没有数据
      noData: false,
      // 没有结果
      noResult: false,
    };
  },
  mounted() {
    this.search = this.$route.query.key.toLowerCase() || "";
    if (!this.search) {
      this.$Message.warning("请输入查询的域名信息！");
      this.loadings = false;
      return false;
    }
    // 获取最后一个带点的数据
    const temp = this.search.match(domain);
    if (temp && temp.length > 0) {
      this.search = temp[0];
    } else {
      this.$Message.warning("请输入正确域名信息！");
      return false;
    }
    this.init();
  },
  methods: {
    refreshWhois() {
      this.$refs.childCaptcha.onShow()
    },
    async getCodeEvent(obj) {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV2(this.search, obj.id, obj.code);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 初始化
    async init() {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV1(this.search);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }
      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$nextTick(() => {
        history.pushState("", "", `/whois?key=${this.search}`);
        this.init();
      });
    },
    toRegister(name) {
      let newName = name.substring(0, name.indexOf("."));
      window.open(`/search?name=${newName}`, "_blank");
    },
  },
};
</script>


<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 160px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .search-input-warp :deep( ) {
      margin-top: 40px;
      width: 100%;
    }
    .whois-left {
      margin-top: 24px;
      background: #fff;
      padding: 20px 38px;
      .form-tit {
        font-size: 30px;
        font-weight: bold;
      }
      .form-stit {
        font-size: 18px;
        margin-top: 10px;
      }
    }
    .contentBox-bottom {
      .whois-content {
        margin-top: 40px;
        background: #fff;
        padding: 20px 38px;
        .whois-top {
          .whios-title {
            padding: 0 25px 20px;
            border-bottom: 1px solid #eeeeee;
          }
          .info-item {
            display: flex;
            line-height: 36px;

            .info-title {
              color: #777777;
              min-width: 130px;
              text-align: right;
            }
            .info-text {
              color: #555555;
              margin-left: 16px;
            }
          }
        }
        .whois-bottom {
          margin-top: 48px;
          .eng-title {
            margin-top: 18px;
            color: #333;
            font-weight: bold;
            padding-bottom: 20px;
            font-size: 14px;
            border-bottom: 1px solid #eeeeee;
            .title-inner {
              padding-bottom: 20px;
              border-bottom: 3px solid #3992e9;
            }
          }
          .content {
            margin-top: 15px;
            color: #666;
            line-height: 28px;
          }
        }
      }
      .noData-content {
        margin-top: 60px;
        min-height: 80px;
        font-size: 16px;
        padding: 20px 25px;
        background: #fff;
        display: flex;
      }
    }
  }
  :deep(.search-input) {
    .ivu-input {
      height: 80px !important;
      padding: 0 0px 0 50px !important;
      font-size: 24px;
      line-height: 80px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      &:focus {
        box-shadow: none;
      }
    }
    .ivu-input-icon-clear {
      line-height: 80px;
      font-size: 24px;
    }
    .ivu-input-group-append {
      width: 170px;
    }
  }
  :deep(.search-btn) {
    height: 80px;
    padding: 0 45px;
    font-size: 22px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    img {
      width: 26px;
      height: 26px;
      position: relative;
      top: 5px;
      margin-right: 15px;
    }
  }
}
</style>
